<template>
  <div class="confirmation__row px-2 md:px-8 xl:px-16">
    <h3 class="confirmation__title">
      {{ t('confirmationComp.title2') }}
    </h3>
  </div>

  <div v-if="extendedInfo?.id" class="confirmation__row  px-2 md:px-8 xl:px-16">
    {{ t('confirmationComp.descrUpdate') }}
  </div>

  <div v-else class="confirmation__row  px-2 md:px-8 xl:px-16">
    {{ t('confirmationComp.descr2') }}
  </div>

  <div v-if="store.getters.professionalContractLoading" class="w-full h-full">
    <Spinner class="absolute top-1 left-1/5"/>
  </div>

  <div v-else-if="contractLoadingError" class="w-full h-full">
    <div class="absolute top-1/2 w-full text-center">
      <div>{{ t('confirmationComp.fields.errorWhileUploadFile') }}</div>
      <btn-wrapper
          class="mx-auto"
          :params="{
          title: t('confirmationComp.fields.retry')
        }"
          @click="loadExtendedInfo"
      />
    </div>
  </div>

  <template v-else>
    <div class="confirmation__row  px-2 md:px-8 xl:px-16 flex-col !grow overflow-auto relative">
      <div class="confirmation__group">
        <label v-for="(item, index) in visibleFields" class="confirmation__group" :key="index">
          <div class="label text_bold text_size_medium">{{ item.title }}</div>
          <template v-for="field in item.values" :key="field.key">
            <template v-if="!field.hidden">
              <template v-if="typeof field.type === 'object'">
                <component
                    :is="field.type"
                    v-bind="field.props || {}"
                    v-model="field.value"
                    @update:modelValue="handleFieldChange(field, $event)"
                    :class="field?.error ? 'border-red-500' : ''"
                />
              </template>
              <input
                  v-else
                  :data-maska="field.mask"
                  v-model="field.value"
                  class="confirmation__input"
                  :class="[field.className || '', field?.error ? 'border-red-500' : '']"
                  :type="field.type || 'text'"
                  :placeholder="field.label"
                  @input="handleFieldChange(field, $event)"
              />
              <p v-if="field.title">{{ field.title }}</p>
              <p class="text-red-500 text-xs mt-1" v-if="field?.error">{{ t('confirmationComp.fieldNecessary') }}</p>
            </template>
          </template>
        </label>
      </div>

      <div class="confirmation__group">
        <div class="label text_bold text_size_medium pb-4">{{ t('confirmationComp.copyDocument') }}</div>

        <template v-if="!files.changefio_docscan.hidden">
          <template v-if="!files.changefio_docscan.file && !extendedInfo.changefio_docscan">
            <label class="confirmation__file-input">
              <input type="file" accept=".pdf, .jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
                     @change="$event => handleFileSelect($event, 'changefio_docscan')"/>
              <btn-wrapper
                  :class="files.changefio_docscan.error ? 'text-red-500 border-red-500' : 'text-slate-600'"
                  :params="{
                  class: 'confirmation__input flex cursor-pointer' + (files.changefio_docscan.error ? ' border-red-500' : ''),
                  type: 'div',
                  title: t('confirmationComp.changefiodocument')
                }"
              >
                <div class="mr-4 flex items-center">
                  <svg class="icon stroke-current">
                    <use xlink:href="/img/sprites/icons-sprite.svg#icon-link"></use>
                  </svg>
                </div>
              </btn-wrapper>
            </label>
            <p class="text-red-500 text-xs mt-1" v-if="files.changefio_docscan.error">
              {{ t('confirmationComp.thisFieldNecessary') }}</p>
          </template>
          <div v-else class="confirmation__document confirmation__input">
            <i class="confirmation__icon">
              <svg class="icon icon_color_blue">
                <use xlink:href="/img/sprites/icons-sprite.svg#icon-file"></use>
              </svg>
            </i>
            <div class="confirmation__file">
              {{ t('confirmationComp.changefiodocument') }}
              <span v-if="extendedInfo.changefio_docscan"
                    class="text-sm text-gray-500">{{ t('confirmationComp.wasUploaded') }}</span>
            </div>
            <svg class="icon confirmation__delete stroke-current" @click="removeFile('changefio_docscan')">
              <use xlink:href="/img/sprites/icons-sprite.svg#icon-close"></use>
            </svg>
          </div>
        </template>

        <template v-if="!files.diplom_scan.hidden">
          <Spinner v-if="diplomaAnalysisInProgress" size="2rem"/>

          <template v-else-if="!files.diplom_scan.file && !extendedInfo.diplom_scan">
            <label class="confirmation__file-input">
              <input type="file"
                     accept=".pdf, .jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
                     @change="$event => handleFileSelect($event, 'diplom_scan')"/>
              <btn-wrapper
                  :class="files.diplom_scan.error ? 'text-red-500 border-red-500' : 'text-slate-600'"
                  :params="{
                  class: 'confirmation__input flex cursor-pointer' + (files.diplom_scan.error ? ' border-red-500' : ''),
                  type: 'div',
                  title: t('confirmationComp.diploma')
                  }">
                <div class="mr-4 flex items-center">
                  <svg class="icon stroke-current">
                    <use xlink:href="/img/sprites/icons-sprite.svg#icon-link"></use>
                  </svg>
                </div>
              </btn-wrapper>
              <p class="text-xs text-gray-500 mt-1">{{ t('confirmationComp.formatAccept') }}</p>
              <p class="text-xs text-gray-500">{{ t('confirmationComp.maxSizeFile') }}</p>
              <div class="text-slate-600 text-sm pb-2">{{ files.diplom_scan.annotation }}</div>
            </label>
            <p class="text-red-500 text-xs mt-1" v-if="files.diplom_scan.error">
              {{ t('confirmationComp.thisFieldNecessary') }}</p>
          </template>

          <div v-else class="confirmation__document confirmation__input">
            <i class="confirmation__icon">
              <svg class="icon icon_color_blue">
                <use xlink:href="/img/sprites/icons-sprite.svg#icon-file"></use>
              </svg>
            </i>
            <div class="confirmation__file">
              {{ t('confirmationComp.diploma') }}
              <span v-if="extendedInfo.diplom_scan"
                    class="text-sm text-gray-500">{{
                  t('confirmationComp.wasUploaded2', { file: extendedInfo.diplom_scan })
                }}</span>
            </div>
            <svg class="icon confirmation__delete stroke-current" @click="removeFile('diplom_scan')">
              <use xlink:href="/img/sprites/icons-sprite.svg#icon-close"></use>
            </svg>
          </div>

          <div v-if="diplomaWarningMessage"
               class="relative flex flex-col items-center gap-2 p-4 pr-10 mb-4 text-sm text-yellow-700 bg-yellow-200 rounded-lg confirmation__group__warning_content">
            <div>
              <span>{{ diplomaWarningMessage }}</span>
              <strong class="block text-center pt-1">{{ t('confirmationComp.diplomaAnalysisTolerate') }}</strong>
            </div>
            <svg class="icon confirmation__warn_clear absolute top-4 right-4" @click="() => diplomaWarningMessage = ''">
              <use xlink:href="/img/sprites/icons-sprite.svg#icon-close"></use>
            </svg>
          </div>
        </template>
      </div>

      <Marker v-model="restrictions.policy2" type="checkbox"
              class="form__checkbox w-full pb-4">
        {{ t('confirmationComp.confirmation.reliability') }}
      </Marker>
      <Marker v-model="restrictions.policy1" type="checkbox" class="form__checkbox">
        {{ t('confirmationComp.confirmation.personal', { hostname }) }}
      </Marker>
    </div>

    <div class="confirmation__row px-2 md:px-8 xl:px-16">
      <btn-wrapper
          @click="registerContract"
          :params="{
          class: 'confirmation__button confirmation__button_next w-full',
          type: 'button',
          title: !registrationProcessing ? t('confirmationComp.sendBtn') : '',
          isSlotIsset: true,
          disabled: registrationProcessing || diplomaAnalysisInProgress || (files.diplom_scan.file && !diplomaAnalyzed)
        }"
      >
        <div v-if="registrationProcessing" role="status">
          <svg aria-hidden="true" class="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-sky-400"
               viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"/>
            <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"/>
          </svg>
          <span class="sr-only">{{ t('confirmationComp.loading') }}</span>
        </div>
      </btn-wrapper>
    </div>
  </template>
</template>

<script>
export default {
  name: 'coursetype-professional'
}
</script>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref, shallowRef, computed, reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification'
import Marker from '@/components/UI/marker/index.vue'
import twSelect from '@/components/UI/SelectWrapper.vue'
import Spinner from '@/components/Spinner.vue'
import useFormProcessor from '../mixin'

const { t } = useI18n()
const store = useStore()
const toast = useToast()
const registrationProcessing = ref(false)

const user = computed(() => store.getters.user)
const userContract = computed(() => store.getters.usercontract)

const diplomaAnalysisInProgress = ref(false)
const diplomaAnalyzed = ref(false)
const diplomaWarningMessage = ref('')
const diplomaAnalysisId = ref(null)

const form = useFormProcessor()

if (user.value && !userContract.value) {
  store.dispatch('getUserContract')
}

const hostname = computed(() => window.location.hostname)

// ** load extended info, if previously completed. For ability user to change data
const contractLoadingError = ref(false)
const extendedInfo = ref({})

const updateFieldsFromExtendedInfo = () => {
  if (!extendedInfo.value || Object.keys(extendedInfo.value).length === 0) {
    return
  }

  fields.forEach(group => {
    group.values.forEach(field => {
      if (field.key && extendedInfo.value[field.key] !== undefined) {
        field.value = extendedInfo.value[field.key]
        if (field.error) {
          field.error = false
        }
      }
    })
  })

  const sameFioField = fields[4].values.find(f => f.key === 'educationdocument_samefio')
  if (sameFioField && sameFioField.value !== undefined) {
    if (sameFioField.handler) {
      sameFioField.handler(sameFioField.value)
    }
  }

  const workplaceField = fields[5].values.find(f => f.key === 'workplace')
  if (workplaceField && workplaceField.value && workplaceField.handler) {
    workplaceField.handler(workplaceField.value)
  }
}

const loadExtendedInfo = () => {
  store.dispatch('getUserContractExtendedInfo').then(result => {
    if (result) {
      extendedInfo.value = result
      updateFieldsFromExtendedInfo()
    }
  }).catch(err => {
    contractLoadingError.value = true
  })
  contractLoadingError.value = false
}
loadExtendedInfo()

watch(extendedInfo, (newValue) => {
  if (newValue && Object.keys(newValue).length > 0) {
    updateFieldsFromExtendedInfo()
  }
}, { deep: true })

const files = reactive({
  diplom_scan: {
    file: null,
    error: null,
    optional: false,
    hidden: false,
    annotation: t('auth.confirmPolicyPaidCourse')
  },
  changefio_docscan: {
    file: null,
    error: null,
    optional: false,
    hidden: true
  }
})

const fields = reactive([
  {
    title: t('confirmationComp.fields.age'),
    values: [
      {
        key: 'age',
        value: '',
        label: '18',
        type: 'number',
        optional: false,
        hidden: false,
        error: null
      }
    ]
  },
  {
    title: t('confirmationComp.fields.gender'),
    values: [
      {
        key: 'gender',
        value: '',
        type: shallowRef(twSelect),
        props: {
          options: [t('confirmationComp.fields.man'), t('confirmationComp.fields.woman')],
          class: 'confirmation__input !p-2',
          placeholder: t('confirmationComp.fields.gender')
        },
        optional: false,
        hidden: false,
        error: null
      }
    ]
  },
  {
    title: t('confirmationComp.fields.citizenship'),
    values: [
      {
        key: 'citizenship_rf',
        value: true,
        type: shallowRef(Marker),
        props: {
          label: t('confirmationComp.fields.citizenshipRF'),
          class: ' !p-2'
        },
        handler: (val) => {
          const citizenshipField = fields[2].values[1]
          if (val) {
            citizenshipField.hidden = true
            citizenshipField.optional = true
            citizenshipField.value = t('confirmationComp.fields.RF')
          } else {
            citizenshipField.hidden = false
            citizenshipField.optional = false
            citizenshipField.value = ''
          }
        },
        optional: true,
        hidden: false,
        error: null
      },
      {
        key: 'citizenship',
        value: 'РФ',
        hidden: true,
        optional: true,
        label: t('confirmationComp.fields.enterCitizenship'),
        error: null
      }
    ]
  },
  {
    title: t('confirmationComp.fields.educationinfo'),
    values: [
      {
        key: 'education',
        value: '',
        label: t('confirmationComp.fields.educationinfo'),
        type: shallowRef(twSelect),
        props: {
          options: [t('confirmationComp.fields.degree'), t('confirmationComp.fields.middleProfessional'), t('confirmationComp.fields.noDegree')],
          class: 'confirmation__input !p-2',
          placeholder: t('confirmationComp.fields.education')
        },
        optional: false,
        hidden: false,
        error: null
      },
      {
        key: 'qualification',
        value: '',
        label: t('confirmationComp.fields.qualificationByDiploma'),
        type: shallowRef(twSelect),
        props: {
          options: [t('confirmationComp.fields.science.master'), t('confirmationComp.fields.science.bachelor'), t('confirmationComp.fields.science.specialist')],
          class: 'confirmation__input !p-2',
          placeholder: t('confirmationComp.fields.qualifications')
        },
        optional: false,
        hidden: false,
        error: null
      }
    ]
  },
  {
    title: t('confirmationComp.fields.educationdocument'),
    values: [
      {
        key: 'educationdocument_series',
        value: '',
        label: t('confirmationComp.fields.passport.documentSeries'),
        optional: false,
        hidden: false,
        error: null
      },
      {
        key: 'educationdocument_number',
        value: '',
        label: t('confirmationComp.fields.passport.documentNumber'),
        optional: false,
        hidden: false,
        error: null
      },
      {
        key: 'educationdocument_fio',
        value: '',
        label: t('confirmationComp.fields.passport.lastNameDiploma'),
        optional: false,
        hidden: false,
        error: null
      },
      {
        type: shallowRef(Marker),
        key: 'educationdocument_samefio',
        value: true,
        props: {
          label: t('confirmationComp.fields.passport.lastNameTheyMatch'),
          class: '!p-2'
        },
        handler: (val) => {
          files.changefio_docscan.hidden = !!val
          if (val) {
            files.changefio_docscan.error = null
          }
        },
        optional: true,
        hidden: false,
        error: null
      }
    ]
  },
  {
    title: t('confirmationComp.fields.otherIntelligence'),
    values: [
      {
        key: 'academic_degree',
        value: '',
        type: shallowRef(twSelect),
        props: {
          options: [t('confirmationComp.fields.intelligence.academic1'), t('confirmationComp.fields.intelligence.academic2'), 'PhD', t('confirmationComp.fields.intelligence.no')],
          class: 'confirmation__input !p-2',
          placeholder: t('confirmationComp.fields.intelligence.academicDegree')
        },
        optional: false,
        hidden: false,
        error: null
      },
      {
        key: 'academic_title',
        value: '',
        type: shallowRef(twSelect),
        props: {
          options: [t('confirmationComp.fields.science.professor'), t('confirmationComp.fields.science.docent'), t('confirmationComp.fields.science.no')],
          class: 'confirmation__input !p-2',
          placeholder: t('confirmationComp.fields.scienceRank')
        },
        optional: false,
        hidden: false,
        error: null
      },
      {
        key: 'workplace',
        value: '',
        type: shallowRef(twSelect),
        props: {
          options: [t('confirmationComp.fields.place.organization'), t('confirmationComp.fields.place.eduOrganization'), t('confirmationComp.fields.place.stateService'), t('confirmationComp.fields.place.municipalService'), t('confirmationComp.fields.place.militaryReverse'), t('confirmationComp.fields.place.anUnemployedPerson'), t('confirmationComp.fields.place.student'), t('confirmationComp.fields.place.noWork')],
          class: 'confirmation__input !p-2',
          placeholder: t('confirmationComp.fields.placeWork')
        },
        handler: (val) => {
          const eduField = fields[5].values[3]
          const studField = fields[5].values[4]
          const managementField = fields[5].values[5]

          if (val && val.toLowerCase().includes(t('confirmationComp.fields.place.education'))) {
            eduField.hidden = false
            eduField.optional = false
          } else {
            eduField.hidden = true
            eduField.optional = true
            eduField.error = null
          }

          if (val && val.toLowerCase().includes(t('confirmationComp.fields.place.student'))) {
            studField.hidden = false
            studField.optional = false
            files.diplom_scan.optional = true
            files.diplom_scan.error = null
          } else {
            studField.hidden = true
            studField.optional = true
            studField.error = null
            files.diplom_scan.optional = false
          }

          if (val && [t('confirmationComp.fields.place.state'), t('confirmationComp.fields.place.municipal')].some(el => val.includes(el))) {
            managementField.hidden = false
            managementField.optional = false
          } else {
            managementField.hidden = true
            managementField.optional = true
            managementField.error = null
          }
        },
        optional: false,
        hidden: false,
        error: null
      },
      {
        key: 'management_level',
        value: '',
        hidden: true,
        optional: true,
        type: shallowRef(twSelect),
        props: {
          options: [t('confirmationComp.fields.place.positionIsRelate'), t('confirmationComp.fields.place.positionIsNotRelate')],
          class: 'confirmation__input !p-2',
          placeholder: t('confirmationComp.fields.place.positionRelate')
        },
        error: null
      },
      {
        key: 'educational_org_type',
        value: '',
        hidden: true,
        optional: true,
        type: shallowRef(twSelect),
        props: {
          options: [t('confirmationComp.fields.place.school.before'), t('confirmationComp.fields.place.school.school'), t('confirmationComp.fields.place.school.professional'), t('confirmationComp.fields.place.school.university'), t('confirmationComp.fields.place.school.additionalProfessional'), t('confirmationComp.fields.place.school.additional')],
          class: 'confirmation__input !p-2',
          placeholder: t('confirmationComp.fields.place.school.type')
        },
        error: null
      },
      {
        key: 'educational_program',
        value: '',
        hidden: true,
        optional: true,
        type: shallowRef(twSelect),
        props: {
          options: [t('confirmationComp.fields.place.educationProgram.full'), t('confirmationComp.fields.place.educationProgram.professional')],
          class: 'confirmation__input !p-2',
          placeholder: t('confirmationComp.fields.place.educationProgram.youLearning')
        },
        error: null
      }
    ]
  }
])

const visibleFields = computed(() => {
  return fields.map(group => ({
    ...group,
    values: group.values.filter(field => !field.hidden)
  })).filter(group => group.values.length > 0)
})

const restrictions = reactive({
  policy1: false,
  policy2: false
})

const removeFile = (fileType) => {
  if (files[fileType].file) {
    Object.assign(files[fileType], { file: null, error: null })
  } else if (extendedInfo.value[fileType]) {
    extendedInfo.value[fileType] = null
    Object.assign(files[fileType], { file: null, error: null })
  }
}

/**
 * Обработчик изменения поля - сбрасывает ошибку при заполнении
 */
const handleFieldChange = (field, event) => {
  if (field.error && field.value && field.value.toString().trim() !== '') {
    field.error = false
  }

  if (field.handler) {
    field.handler(event)
  }
}

const handleFileSelect = async (event, fileType) => {
  const file = event.target.files[0]
  if (!file) return

  const allowedTypes = [
    'application/pdf', 'image/jpeg', 'image/jpg',
    'image/png', 'image/gif', 'image/bmp', 'image/tif', 'image/tiff'
  ]
  const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tif', '.tiff']
  const maxFileSize = 8 * 1024 * 1024

  const fileExtension = '.' + file.name.toLowerCase().split('.').pop()
  const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension)
  const isValidSize = file.size <= maxFileSize

  if (!isValidType) {
    toast.error(t('confirmationComp.errorFormatFile2'))
    files[fileType].file = null
    event.target.value = ''
    return
  }

  if (!isValidSize) {
    toast.error(t('confirmationComp.errorSizeFile'))
    files[fileType].file = null
    event.target.value = ''
    return
  }

  files[fileType].file = file
  files[fileType].error = null

  if (fileType === 'diplom_scan') {
    diplomaAnalyzed.value = false
    diplomaAnalysisId.value = null
    await submitDiplomaToAnalyze(fileType)
  }
}

/**
 * Sends diploma scan for analysis by AIDocScanner
 * @param fileName {String}
 * @returns {Promise<void>}
 */
const submitDiplomaToAnalyze = async (fileName) => {
  const file = files[fileName].file
  if (!file) {
    toast.error(t('files.noFileSelected'))
    return
  }
  diplomaAnalysisInProgress.value = true
  diplomaWarningMessage.value = ''
  store.dispatch('aidocsanner/analyzeFile', { file }).then((resp) => {
    const data = resp.data
    if (data.service_enabled) {
      diplomaAnalysisId.value = data.prediction_id
      if (data.image_type !== 'Diploma') {
        diplomaWarningMessage.value += t('confirmationComp.diplomaAnalysisFailed') + '\n'
      }
      if (!data.extracted_text) {
        diplomaWarningMessage.value += t('confirmationComp.diplomaAnalysisTextExtractionFailed') + '\n'
      } else {
        if (form.field.document_series + ' ' + form.field.document_number !== data.extracted_text) {
          diplomaWarningMessage.value += t('confirmationComp.diplomaNumberDiffers')
        }
      }
    }
  }).catch((resp) => {
    console.error(resp.data.message)
  }).finally(() => {
    diplomaAnalyzed.value = true
    diplomaAnalysisInProgress.value = false
  })
}

const validateAllFields = () => {
  let isValid = true

  fields.forEach(group => {
    group.values.forEach(field => {
      if (!field.hidden && !field.optional) {
        const isEmpty = !field.value || field.value.toString().trim() === ''
        if (isEmpty) {
          field.error = true
          isValid = false
        } else {
          field.error = false
        }
      } else {
        field.error = false
      }
    })
  })

  Object.keys(files).forEach(fileType => {
    const file = files[fileType]
    if (!file.hidden && !file.optional) {
      const isEmpty = !file.file && !extendedInfo.value[fileType]
      if (isEmpty) {
        file.error = true
        isValid = false
      } else {
        file.error = false
      }
    } else {
      file.error = false
    }
  })

  if (!restrictions.policy1 || !restrictions.policy2) {
    isValid = false
  }

  return isValid
}

const registerContract = async () => {
  const isValid = validateAllFields()

  if (!isValid) {
    toast.error(t('confirmationComp.fields.place.requiredFields'))
    return
  }

  const payload = {}
  fields.forEach(group => {
    group.values.forEach(field => {
      if (field.value !== undefined && field.value !== null) {
        payload[field.key] = field.value
      }
    })
  })

  Object.keys(files).forEach(fileType => {
    if (files[fileType].file) {
      payload[fileType] = files[fileType].file
    } else if (extendedInfo.value[fileType]) {
      payload[fileType] = extendedInfo.value[fileType]
    }
  })

  if (files.diplom_scan.file && diplomaAnalysisId.value) {
    payload.diplomaAnalysisId = diplomaAnalysisId.value
  }

  Object.keys(payload).forEach(key => {
    if (payload[key] === undefined) {
      payload[key] = ''
    }
  })

  registrationProcessing.value = true
  try {
    const resp = await store.dispatch('addUserinfoToContract', payload)
    toast.info(resp.message || t('confirmationComp.success'))
    store.commit('setIsActiveConfirm', false)
  } catch (error) {
    toast.error(t('confirmationComp.fields.place.errorWhileSendData'))
  } finally {
    registrationProcessing.value = false
  }
}
</script>

<style scoped lang="scss">
@import "../../scss/confirmation.scss";
</style>